<div class="main-height" [ngClass]="{'home-bg-img':isHomePage}">
    @if(sidenavShow){
    <div [ngClass]="{'transparent-header':isHomePage}">
        <app-sidebar (onToggleSideNav)="onToggleSideNav($event)"></app-sidebar>
    </div>
    }
    <div [ngClass]="scrollSection" #dataContainer>
        <router-outlet (activate)="onScroll($event,dataContainer)"></router-outlet>
    </div>

</div>



<app-piece-promotion></app-piece-promotion>

@if(toster){
<app-toast></app-toast>
}